import { makeAutoObservable, runInAction } from 'mobx';
import { request } from '@/common';

class ExampleStore {
  data = {
    activeTab: '',
    tabList: [],
    tabShowMaxIndex: 0,
    dataList: [],
    npt: ""
  }

  constructor() {
    makeAutoObservable(this);
  }

  setData(n) {
    runInAction(() => {
      this.data = {
        ...this.data,
        ...n
      }
    })
  }

  reset() {
    this.setData({
      activeTab: '',
      tabList: [],
      tabShowMaxIndex: [],
      dataList: [],
      npt: ""
    })
  }

  getCategory(cb) {
    request.get('/ai_agent/example/category').then(res => {
      const data = res?.data || []
      this.setData({
        activeTab: data[0]?.category || "",
        tabList: data
      })
      cb && cb()
    });
  }

  getExampleList(cb) {
    request.get('/ai_agent/example/category_idx', {
      params: {
        category: this.data.activeTab,
        npt: this.data.npt
      }
    }).then(res => {
      const data = res?.data?.list || []
      const npt = res?.data?.npt || ""
      this.setData({
        dataList: [...this.data.dataList, ...data],
        npt: npt
      })
      cb && cb(res?.data || {})
    });
  }

  exchange(index1, index2) {
    const tabList = this.data.tabList
    const newTabList = [
      ...tabList.slice(0, index1),
      tabList[index2],
      ...tabList.slice(index1 + 1, index2),
      tabList[index1],
      ...tabList.slice(index2 + 1)
    ]
    this.setData({
      tabList: newTabList
    })
  }
}

const exampleStore = new ExampleStore();

export default exampleStore